import AuthStepsEnum from './AuthStepsEnum';
import useStepByStepAuthContext from './context/hooks/useStepByStepAuthContext';
import EnterPasswordStep from './EnterPasswordStep';
import FinishSignupStep from './FinishSignupStep';
import LoginOrSignupStep from './LoginOrSignupStep';
import Uses2FAStep from './Uses2FAStep';
import MoreOptionsStep from './Uses2FAStep/MoreOptionsStep';

type Props = {
  onSubmitHandle?: () => void;
  isPopover: boolean;
};

const AuthSteps: FC<Props> = ({ onSubmitHandle, isPopover }) => {
  const { step, setStep } = useStepByStepAuthContext();

  const handleContinueClick = (authStep: AuthStepsEnum) => {
    setStep(authStep);
  };

  if (step === AuthStepsEnum.EmailOrUsername) {
    return (
      <LoginOrSignupStep
        onContinueClick={handleContinueClick}
        isPopover={isPopover}
      />
    );
  }
  if (step === AuthStepsEnum.EnterPassword) {
    return <EnterPasswordStep isPopover={isPopover} />;
  }
  if (step === AuthStepsEnum.EnterSms2fa) {
    return <Uses2FAStep isPopover={isPopover} />;
  }

  if (step === AuthStepsEnum.MoreOptions) {
    return <MoreOptionsStep isPopover={isPopover} />;
  }

  return (
    <FinishSignupStep onSubmitHandle={onSubmitHandle} isPopover={isPopover} />
  );
};

export default AuthSteps;
